<section mat-dialog-title>
  <h1>
    <span id="dialogTitle">{{ data.title || 'uix.popUpDialog.title' | translate }}</span>
    <mat-icon id="dialogTitleIcon">edit</mat-icon>
  </h1>
</section>

<section mat-dialog-content>
  @if (data.message) {
    <p class="dialog-message">{{ data.message | translate }}</p>
  }
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ data.placeholder || 'commons.labels.name' | translate }}</mat-label>
    <input (keydown.enter)="onConfirm()" [formControl]="textControl" [placeholder]="data.placeholder || 'commons.labels.name' | translate" cdkFocusInitial matInput />
    @if (textControl.hasError('required')) {
      <mat-error>{{ 'commons.validations.required' | translate }}</mat-error>
    }
  </mat-form-field>
</section>

<section class="pull-right" mat-dialog-actions>
  <button (click)="onCancel()" data-role="cancel" id="cancelBtn" mat-button>
    {{ 'commons.btn.cancel' | translate }}
  </button>
  <button (click)="onConfirm()" [disabled]="textControl.invalid" color="primary" data-role="confirm" id="confirmBtn" mat-raised-button>
    {{ 'commons.btn.confirm' | translate }}
  </button>
</section>
